<template>
    <div class="myTable">
        <div class="searchNav">
            <span>
                            <span class="searchNameStyle">操作时间 ：</span>
                            <el-date-picker
                                    v-model="opSearchInfo.date"
                                    type="date"
                                    value-format="yyyy-MM-dd"
                                    placeholder="选择日期">
                            </el-date-picker>
                        </span>
            <el-button type="primary" icon="el-icon-search" @click="search" style="float: right; position: relative;left: -20px;" >搜索</el-button>
        </div>
        <div class="tableStyle">
            <el-table v-loading="opLoading" :data="opTableData" style="width: 100%;" :row-class-name="tableRowClassName">
                <el-table-column
                        type="index"
                        width="50">
                </el-table-column>
                <el-table-column label="账号" >
                    <template slot-scope="scope">
                        {{ scope.row.userId | showAccount }}
                    </template>
                </el-table-column>
<!--                <el-table-column prop="httpMethod" label="请求类型"></el-table-column>-->
                <el-table-column prop="httpMethod" label="请求操作">
                    <template slot-scope="scope">
                        {{ scope.row.httpMethod | showHttpMethod }}
                    </template>
                </el-table-column>
                <el-table-column prop="url" label="调用的方法"></el-table-column>
                <el-table-column prop="operationTime" label="操作时间"></el-table-column>

                <el-table-column prop="enabled" label="请求状态">
                    <template slot-scope="scope">
                        {{ scope.row.succeed | showState }}
                    </template>
                </el-table-column>
                <!-- 自定义空数据展示 -->
                <template slot="empty">
                    <div class="empty-container">
                        <el-empty :image-size="200"></el-empty>
                    </div>
                </template>
            </el-table>
        </div>
    </div>
</template>

<script>
    import {axios} from "../../config/axios";
    let userMap = new Map();
    export default {
        name: "operation-log",
        data () {
            return {
                loginDate:'',
                total:1,
                tableData: [],
                currentPage:1,
                loading:false,
                opTotal:1,
                opTableData: [],
                opCurrentPage:1,
                opLoading:false,
                searchInfo:{
                    date:'',
                    account:'',
                    pageNumber:1,
                    pageSize:50,
                },
                opSearchInfo:{
                    date:'',
                    account:'',
                    pageNumber:1,
                    pageSize:50,
                },
                activeName: 'first',
            }
        },
        created: function () {
            let role = localStorage.getItem("logistics-userInfo");
            if (JSON.parse(role).role === "admin") {
                this.getUserList();
            }else{
                this.pageInfo();
                this.operationLogInfo();
            }
        },
        watch: {
            'searchInfo.date'(newVal,oldVal){
                if (null == newVal){
                    this.pageInfo();
                    this.operationLogInfo();
                }
            },
            'opSearchInfo.date'(newVal,oldVal){
                if (null == newVal){
                    this.pageInfo();
                    this.operationLogInfo();
                }
            },
        },
        methods: {
            pageInfo() {
                axios.get('/accountLog', {
                    params: this.searchInfo
                }).then(result => {
                    this.loading = false;
                    if (result.code !== 200) {
                        console.log(result);
                    }
                    let page = result.data;
                    this.total = page.total;
                    this.tableData = page.list;
                }).catch(err => {
                    console.log(err);
                    this.loading = false;
                });
            },

            handleSizeChange(val) {
                console.log(`每页 ${val} 条`);
                this.currentPage = 0;
                this.searchInfo.pageSize = val ;
                this.pageInfo();
            },
            operationLogInfo() {
                axios.get('/operationLog', {
                    params: this.opSearchInfo
                }).then(result => {
                    this.opLoading = false;
                    if (result.code !== 200) {
                        console.log(result);
                    }
                    let page = result.data;
                    this.opTotal = page.total;
                    this.opTableData = page.list;
                }).catch(err => {
                    console.log(err);
                    this.opLoading = false;
                });
            },
            search(){
                this.pageInfo();
            },
            handleClick(tab, event) {
                console.log(tab, event);
            },
            handleCurrentChange(val) {
                this.currentPage = val;
                this.searchInfo.pageNumber = val;
                this.pageInfo();
            },
            opHandleCurrentChange(val) {
                this.opccurrentPage = val;
                this.opSearchInfo.pageNumber = val;
                this.operationLogInfo();
            },
            //改为全局方法
            getUserList(){
                axios.get('/user/all',{
                    params: this.searchInfo
                }).then(result => {
                    this.loading=false;
                    if (result.code !== 200){
                        console.log(result);
                    }
                    result.data.forEach(item =>{
                        userMap.set(item.id,item.account);
                    });
                    this.pageInfo();
                    this.operationLogInfo();
                })
            }
        },
        filters: {
            showState(v){
                if (v){
                    return "成功";
                } else{
                    return "失败";
                }
            },
            showHttpMethod(v){
                if (v=="GET"){
                    return "查询";
                }
                if (v=="PUT"){
                    return "编辑";
                }
                if (v=="DELETE"){
                    return "删除";
                }
                if (v=="POST"){
                    return "新增";
                }
                return "--";
            },
            showLogType(val){   //1:login,2:logout,3:register
                switch(val){
                    case 1 :
                        return "登录";
                        break; //可选
                    case 2 :
                        return "退出";
                        break; //可选
                    //你可以有任意数量的case语句
                    default : //可选
                        return "注册";
                }
            },
            showAccount(val){
                let result = userMap.get(val);
                if(typeof (result) !== "undefined"){
                    return result ;
                }
                return val;
            }
        }
    }
</script>

<style scoped>

</style>
